import { FC } from 'react';
import { makeStyles } from 'tss-react/mui';
import {
  ConfigureConnectionInput,
  Connection,
} from '../types/connection-types';
import AddRemoveButtonSwitcher from './AddRemoveButtonSwitcher';
import { Nullable } from 'common-types';
import { Box, Typography } from '@mui/material';

const ConnectionForm: FC<
  React.PropsWithChildren<ConnectionFormProps>
> = props => {
  const { classes } = useStyles();
  const {
    onClose,
    connection,
    onAddConnection,
    onRemoveConnection,
    isReadOnlyRole,
    isLoadingAdd,
    isLoadingRemove,
    isSelfConnection,
    errorMessage,
  } = props;

  return (
    <form className={classes.rootForm}>
      <AddRemoveButtonSwitcher
        connection={connection}
        onAddConnection={onAddConnection}
        onRemoveConnection={onRemoveConnection}
        onClose={onClose}
        isReadOnlyRole={isReadOnlyRole}
        isLoadingAdd={isLoadingAdd}
        isLoadingRemove={isLoadingRemove}
        isSelfConnection={isSelfConnection}
      />
      {errorMessage && (
        <Box flexGrow={1} mt={1} textAlign='end'>
          <Typography color='error' variant='body2'>
            {errorMessage}
          </Typography>
        </Box>
      )}
    </form>
  );
};

const useStyles = makeStyles()({
  rootForm: {
    width: '100%',
  },
});

export interface ConnectionFormProps {
  connection: Connection;
  onClose: () => void;
  onAddConnection: (configureConnectionInput: ConfigureConnectionInput) => void;
  onRemoveConnection: (
    configureConnectionInput: ConfigureConnectionInput,
  ) => void;
  isReadOnlyRole: boolean;
  isLoadingAdd: boolean;
  isLoadingRemove: boolean;
  isSelfConnection: boolean;
  errorMessage: Nullable<string>;
}

export default ConnectionForm;
